"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextToVoiceCreatePreviewsRequestOutputFormat = void 0;
exports.TextToVoiceCreatePreviewsRequestOutputFormat = {
    Mp32205032: "mp3_22050_32",
    Mp34410032: "mp3_44100_32",
    Mp34410064: "mp3_44100_64",
    Mp34410096: "mp3_44100_96",
    Mp344100128: "mp3_44100_128",
    Mp344100192: "mp3_44100_192",
    Pcm8000: "pcm_8000",
    Pcm16000: "pcm_16000",
    Pcm22050: "pcm_22050",
    Pcm24000: "pcm_24000",
    Pcm44100: "pcm_44100",
    Ulaw8000: "ulaw_8000",
};
